/**
 * @description A middleware pattern which encapsulated the most commmon XHR patterns. For any REST call will generate two actions. REQ*{NAME} and one of RECV*{NAME} | XHR*ERROR*{NAME}. Has hooks for caching and matching responses with request. Adapted from the Redux Docs on reducing boilderplate
 * @example usage
 *  export function getTrades(date) {
 *        return {
 *            baseType: 'TRADES', //
 *            callAPI: (state, payload) => request.get(`/trades/${date}`), // required. Function returning a promise
 *            shouldCallAPI: (state, payload) => true, // optional function letting you determine to call the XHR or not
 *            payload: { date }, // optional, but recommended so you can correlate the request with the response in cases of out of order responses
 *    }
 * @example configuration
 *    import { callAPIMiddleware } from '@mq/aurora-redux-middleware';
 *    const middleware = applyMiddleware(thunkMiddleware, callAPIMiddleware, ...);
 * @author adapted from http://rackt.github.io/redux/docs/recipes/ReducingBoilerplate.html
 */
var callAPIMiddleware = function (store) {
  return function (next) {
    return function (action) {
      var apiAction = action;
      var baseType = apiAction.baseType,
        callAPI = apiAction.callAPI,
        _a = apiAction.shouldCallAPI,
        shouldCallAPI = _a === void 0 ? function () {
          return true;
        } : _a,
        _b = apiAction.payload,
        payload = _b === void 0 ? {} : _b;
      if (!baseType) {
        // Normal action: pass it on
        return next(action);
      }
      if (typeof baseType !== 'string') {
        throw new Error('field "baseType" must be a string');
      }
      if (typeof callAPI !== 'function') {
        throw new Error('Expected callAPI to be a function.');
      }
      if (!shouldCallAPI(store.getState(), payload)) {
        return Promise.resolve();
      }
      var _c = ['REQ', 'RECV', 'XHR_ERROR'].map(function (prefix) {
          return prefix + "_" + baseType;
        }),
        requestType = _c[0],
        successType = _c[1],
        failureType = _c[2];
      store.dispatch({
        type: requestType,
        payload: payload
      });
      return callAPI(store.getState(), payload).then(function (response) {
        return store.dispatch({
          type: successType,
          response: response,
          payload: payload,
          lastUpdated: Date.now()
        });
      }, function (error) {
        return store.dispatch({
          type: failureType,
          error: error,
          payload: payload,
          receivedAt: Date.now()
        });
      });
    };
  };
};
export { callAPIMiddleware };